import { useCallback } from "react";

import type { BedType } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";
import { QuestionCardItem } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-item";
import { QuestionCardItemsWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/card/card-items-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useRoomBedType } from "./hooks";

export const QuestionRoomBedType = () => {
	const {
		beds,
		onSetBedNum: _onSetBedNum,
		onSetBedType: _onSetBedType,
		appendItem,
		removeItem: _removeItem,
		options,
		isEdited,
		hasError,
	} = useRoomBedType();

	const onSetBedType = useCallback(
		(index: number) => (value: string) => {
			_onSetBedType(value as BedType, index);
		},
		[_onSetBedType],
	);

	const onSetBedNum = useCallback(
		(index: number) => (value: number | undefined) => {
			_onSetBedNum(value, index);
		},
		[_onSetBedNum],
	);

	const removeItem = useCallback(
		(index: number) => () => {
			_removeItem(index);
		},
		[_removeItem],
	);

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"ベッドのタイプ"}
			guide="部屋にあるベッドタイプが設定できます。部屋詳細ページで表示されます。"
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<QuestionCardItemsWrapper appendItem={appendItem}>
					{beds.value.map((item, index) => {
						return (
							<QuestionCardItem key={index} removeItem={removeItem(index)}>
								<QuestionSectionWrapper>
									<SelectField
										placeholder="選択"
										value={item.bedType.value}
										options={options}
										handleValueChange={onSetBedType(index)}
										errorMessage={item.bedType.error}
									/>
									<p>が</p>
									<InputNumberField
										value={item.bedNum.value}
										handleInput={onSetBedNum(index)}
										errorMessage={item.bedNum.error}
										hiddenSpinButton={false}
									/>

									<p>台</p>
								</QuestionSectionWrapper>
							</QuestionCardItem>
						);
					})}
				</QuestionCardItemsWrapper>
			}
		/>
	);
};

QuestionRoomBedType.displayName = "QuestionRoomBedType";
